module.exports = __webpack_public_path__ + "static/media/membership-crown.1efca756.svg";